var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.pullApp()}}},[_vm._v("请使用浏览器打开")])
}
var staticRenderFns = []

export { render, staticRenderFns }